import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import CurrencyFormat from "react-currency-format";
import { useStateContext } from "../../../context/StateContext_KO";
import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
const Subtotal_Korea = ({ noShipping, taxPrice }) => {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(true);
  const [remained, setRemained] = useState(null);
  const [basketQuantity, setBasketQuantity] = useState(null);
  const {
    basket,
    getBasketTotal,
    getBasketQuantity,
    getSubtotal,
    getShipping,
    freeshippingRate,
    finalPrice,
    shippingRate,
  } = useStateContext();

  let subtotal = getSubtotal();

  console.log(subtotal);
  useEffect(() => {
    setBasketQuantity(getBasketQuantity());
  }, []);
  useEffect(() => {
    setBasketQuantity(getBasketQuantity());
  }, [basket]);
  useEffect(() => {
    if (subtotal < freeshippingRate && basket.length > 0) {
      setRemained(freeshippingRate - subtotal);
    } else {
      setRemained(null);
    }
  }, [basket, subtotal, freeshippingRate]);

  return (
    <Box sx={{ py: 3 }}>
      {show && remained && !noShipping && (
        <Box sx={{ pb: 3, color: "orange" }}>
          <Alert sx={{ fontSize: "11px" }} onClose={() => setShow(false)}>
            <CurrencyFormat
              renderText={(remained) => (
                <strong>
                  {t("away")}
                  {remained} {t("away from free shipping")}
                </strong>
              )}
              decimalScale={2}
              value={remained}
              displayType={"text"}
              thousandSeparator={true}
              suffix={"원"}
            />
          </Alert>
        </Box>
      )}
      <>
        <Box sx={{ pb: 3, color: "#153a5a" }}>
          <ShoppingCartIcon
            sx={{
              color: "lightgray",
              fontSize: "22px",
              position: "relative",
              top: "+4px",
              fontWeight: 800,
              fontFamily: "HallymGothic-Medium",
            }}
          />{" "}
          고객님의 주문내역
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
          }}
        >
          <Box>
            {t("subtotal")} ({basketQuantity}{" "}
            {getBasketQuantity() > 1 ? t("items") : t("item")}):
          </Box>

          <CurrencyFormat
            renderText={(subtotal) => <strong>{subtotal}</strong>}
            decimalScale={2}
            value={subtotal}
            displayType={"text"}
            thousandSeparator={true}
            suffix={"원"}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            pt: 2,
          }}
        >
          <Box>{t("shipping")}:</Box>

          <Box>
            <strong>
              {+getSubtotal() < freeshippingRate ? (
                <CurrencyFormat
                  // renderText={(5) => <strong>{5}</strong>}
                  decimalScale={2}
                  value={shippingRate}
                  displayType={"text"}
                  thousandSeparator={true}
                  suffix={"원"}
                />
              ) : (
                t("free_shipping")
              )}
            </strong>
          </Box>
        </Box>
        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "15px",
            pt: 2,
          }}
        >
          <Box>{t("tax")}:</Box>
          <Box>
            {taxPrice ? (
              <CurrencyFormat
                renderText={(taxPrice) => <strong>{taxPrice}</strong>}
                decimalScale={2}
                value={taxPrice}
                displayType={"text"}
                thousandSeparator={true}
                suffix={"원"}
              />
            ) : (
              "TBD"
            )}
          </Box>
        </Box> */}
        <Box
          sx={{
            paddingTop: "10px",
            width: 1,
            borderBottom: "1px solid black",
            pb: 3,
          }}
        ></Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            pt: 2,
          }}
        >
          <Box>{t("total")}:</Box>
          <Box>
            {subtotal < freeshippingRate ? (
              <CurrencyFormat
                renderText={(subtotal) => <strong>{subtotal}</strong>}
                decimalScale={2}
                value={subtotal + shippingRate}
                displayType={"text"}
                thousandSeparator={true}
                suffix={"원"}
              />
            ) : (
              <CurrencyFormat
                renderText={(subtotal) => <strong>{subtotal}</strong>}
                decimalScale={2}
                value={subtotal}
                displayType={"text"}
                thousandSeparator={true}
                suffix={"원"}
              />
            )}
          </Box>
        </Box>
      </>
    </Box>
  );
};

export default Subtotal_Korea;
